import { tv } from "tailwind-variants";

export const unreadBadgeVariants = tv({
  base: "min-w-[26px] rounded-full px-2 py-[2px] text-center text-[10px] font-semibold leading-none",
  variants: {
    intent: {
      unreadActivity:
        "bg-study-group-mention-background text-study-group-mention-text",
      mention: "bg-study-group-unread text-white",
    },
  },
});
